// import React from "react";
// import { Col, Row } from "react-bootstrap";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// const SkeletonScreen = () => {
//   const skeletonStyles = {
//     width: "383px",
//     height: "300px",
//     padding: "24px",
//     borderRadius: "10px",
//     display: "flex",
//     justifyContent: "space-between",
//     backgroundColor: "#F0F0F080",
//   };

//   return (
//     <Row className="row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 mb-3">
//       <Col>
//         <div style={skeletonStyles}>
//           <Skeleton
//             enableAnimation
//             height="100%"
//             width="100%"
//             borderRadius="10px"
//             duration={8}
//           />
//         </div>
//       </Col>
//       <Col>
//         <div style={skeletonStyles}>
//           <Skeleton
//             enableAnimation
//             height="100%"
//             width="100%"
//             borderRadius="10px"
//             duration={8}
//           />
//         </div>
//       </Col>
//       <Col>
//         <div style={skeletonStyles}>
//           <Skeleton
//             enableAnimation
//             height="100%"
//             width="100%"
//             borderRadius="10px"
//             duration={8}
//           />
//         </div>
//       </Col>
//     </Row>
//   );
// };

// export default SkeletonScreen;


import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonScreen = ({ count = 3 }) => {
  const skeletonStyles = {
    width: "383px",
    height: "300px",
    padding: "24px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: "#F0F0F080",
  };

  return (
    <Row className="row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 mb-3">
      {Array.from({ length: count }).map((_, index) => (
        <Col key={index}>
          <div style={skeletonStyles}>
            <Skeleton
              enableAnimation
              height="100%"
              width="100%"
              borderRadius="10px"
              duration={8}
            />
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default SkeletonScreen;
